import React from 'react';
import PropTypes from 'prop-types';
import Code from '../code/code';
const MarkdownCode = ({ children, language, inline, className }) => {
    // Hack for updated react-markdown RG-2193
    const lang = language ?? (className?.
        split(' ').
        find(name => name.startsWith('language-'))?.
        replace('language-', ''));
    return (<Code language={lang} className={className} code={children?.join('') || ''} inline={inline}/>);
};
MarkdownCode.propTypes = {
    language: PropTypes.string,
    children: PropTypes.array.isRequired,
    inline: PropTypes.bool
};
export default MarkdownCode;
